export const RoutesList = {
  LANDING_PAGE: '/',
  ITEM_DETAIL_PAGE: '/item-detail',
};

export const NetworkId = {
  mainnet: '1',
  goerli: '5',
  hardhat: '31337',
};

export const ModalStatus = {
  request: 0,
  error: 1,
  success: 2,
  apiPending: 3,
};

export const LISTING_RECORDS_PER_PAGE = 20;

export default RoutesList;
